import PayoutSuccess from 'assets/images/manage/organisations/payout_success.svg'
import classNames from 'classnames'
import React, { useCallback, useEffect, useState } from 'react'
import styles from './payout_success_modal.module.css'
import { PayoutSuccessModalProps } from './types'
import { Modal } from 'src/shared'

const WirWunderContent = () => {
  useEffect(() => {
    if (document.getElementById('smcx-sdk')) return

    const script = document.createElement('script')
    script.id = 'smcx-sdk'
    script.src =
      'https://widget.surveymonkey.com/collect/website/js/tRaiETqnLgj758hTBazgd2nbLDuXpbmxf6_2F_2F0IxspLAR_2F6h61bJg_2F5rJcAuhgr7p.js'

    const container = document.getElementById('survey-widget-container')
    if (container) {
      container.appendChild(script)
    }
  }, [])

  return (
    <>
      <h2 className={classNames('text-2xl', styles.innerHeading)}>
        {i18n.t('manage.organisations.payout_success_modal.wirwunder_heading')}
      </h2>
      <p>{i18n.t('manage.organisations.payout_success_modal.wirwunder_text')}</p>
      <div className={styles.surveyOuterContainer} id="survey-widget-container" />
    </>
  )
}

const Content = ({ wirwunder }: { wirwunder: React.ReactNode }) => {
  return (
    <div className={styles.contentWrapper}>
      <img
        src={PayoutSuccess}
        alt={i18n.t('manage.organisations.payout_success_modal.img_alt')}
        className={classNames(styles.successImage, { [styles.hiddenOnMobile!]: wirwunder })}
      />
      {i18n.t('manage.organisations.payout_success_modal.default_text')}
      {wirwunder && <WirWunderContent />}
    </div>
  )
}

const Footer = ({ wirwunder, onClick }: { wirwunder: React.ReactNode; onClick: () => void }) => {
  const buttonKind = wirwunder ? 'outline-green' : 'primary'
  return (
    <button type="button" className={`btn btn-large btn-${buttonKind}`} onClick={onClick}>
      {i18n.t('misc.close')}
    </button>
  )
}

export const PayoutSuccessModal = (props: PayoutSuccessModalProps) => {
  const [showModal, setShowModal] = useState(true)
  const onHide = useCallback(() => setShowModal(false), [])
  if (!showModal || !props.type) return null

  const wirwunder = props.type === 'wirwunder'
  const content = <Content wirwunder={wirwunder} />
  const footer = <Footer wirwunder={wirwunder} onClick={onHide} />
  return (
    <Modal
      {...props}
      header={i18n.t('manage.organisations.payout_success_modal.heading')}
      content={content}
      show={true}
      onHide={onHide}
      size="modal-lg"
      footer={footer}
    />
  )
}

export default PayoutSuccessModal
